import { faker } from '@faker-js/faker'

import { asBuilder } from '../asBuilder'
import { ExtraPriceListItem, ExtraPriceType } from '../../contracts/service-offer/AdminServiceOfferExtraPrice'

export const getExtraPriceListItem = asBuilder((): ExtraPriceListItem => {
  return {
    name: faker.lorem.word(1),
    type: faker.helpers.enumValue(ExtraPriceType),
  }
})


